<div>
  <div class="projects">
    <div *ngIf="showSpinner" class="progress-spinner">
      <mat-spinner></mat-spinner>
    </div>
    <h1 class="project-title">Demokratiewerkstatt</h1>
    <div class="label">
      <p style="text-align: center; margin-block: 30px;">
        Die Demokratiewerkstatt „Demokratie trifft Kultur“ (DtK) ist eine Kooperation zwischen der Landeszentrale für
        politische Bildung NRW, dem Bildungswerk Vielfalt des VMDO e. V. und dem Schauspiel Dortmund. Kultur und Kunst
        nutzen wir als zentrale Bezugspunkte für eine Auseinandersetzung mit der politischen Gegenwart.<br>
        Unsere politischen Bildungsangebote vernetzten wir mit künstlerischer und kultureller Bildung und schaffen so
        einen Bildungsraum, der eine multi-ethische Perspektive ermöglicht.<br>
        Der Prozess des Aushaltens und Aushandelns ist der Grundstein unserer
        Demokratie und Basis alles Angebote der DtK.
      </p>
    </div>
    <div class="content-page">
      <div class="courses" *ngFor="let workStation of demokratiewerkstattList">
        <div class="example-card" routerLink="{{ workStation.id }}">
          <div class="logoTitle">
            <div class="logo-content-title">
              <img
                mat-card-image
                [src]="workStation.demokratiewerkstatt_icon_url?.trim() ? workStation.demokratiewerkstatt_icon_url : image"
                alt="{{ workStation.title }}"
                [style.display]="workStation.demokratiewerkstatt_icon_url === 'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg' ? 'none' : 'block'"
              />
              <div class="titleDiv">
                {{ workStation.title }}
                <div class="toolTipM">
                  {{ workStation.fullTitle }}
                </div>
              </div>
            </div>
            <div>
              <div class="location">
                <div class="location-title">
                  Wann: {{ workStation.start_date | date }} -
                  {{ workStation.end_date | date }}
                </div>
                <div class="location-title">Wo: {{ workStation.location }}</div>
              </div>
            </div>
          </div>
          <div class="proj-content-img" *ngIf="workStation.showProjectImage">
            <div class="image-proj-container">
              <img
                mat-card-image
                src="{{ workStation.demokratiewerkstatt_image_url }}"
                alt="{{ workStation.title }}"
              />
            </div>
          </div>
          <div [ngClass]="{ 'no-image': workStation.demokratiewerkstatt_image_url === '' }">
            <p class="proj-content">
              {{ workStation.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator
      class="custom-mat-paginator"
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
      (page)="OnPageChange($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</div>
